import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from '@panneau/element-icon';

var propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  labelTrue: PropTypes.string,
  labelFalse: PropTypes.string,
  iconTrue: PropTypes.string,
  iconFalse: PropTypes.string
};
var defaultProps = {
  value: null,
  labelTrue: null,
  labelFalse: null,
  iconTrue: null,
  iconFalse: null
};
var Boolean = function Boolean(_ref) {
  var value = _ref.value,
    iconTrue = _ref.iconTrue,
    iconFalse = _ref.iconFalse,
    labelTrue = _ref.labelTrue,
    labelFalse = _ref.labelFalse;
  return value !== null && (value === true || value === 'true') ? /*#__PURE__*/React.createElement("span", {
    className: "badge bg-success"
  }, iconTrue !== null ? /*#__PURE__*/React.createElement(Icon, {
    name: iconTrue
  }) : labelTrue || /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "9XBwF1",
    defaultMessage: [{
      "type": 0,
      "value": "Yes"
    }]
  })) : /*#__PURE__*/React.createElement("span", {
    className: "badge bg-warning"
  }, iconFalse !== null ? /*#__PURE__*/React.createElement(Icon, {
    name: iconFalse
  }) : labelFalse || /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "rSt+KL",
    defaultMessage: [{
      "type": 0,
      "value": "No"
    }]
  }));
};
Boolean.propTypes = propTypes;
Boolean.defaultProps = defaultProps;

export { Boolean as default };
